import React from 'react';

import { useCandidatesResultsContext } from '../../../../../Contexts/CandidateResultsContext';

import EICharacteristicPanel from './Components/EICharacteristicPanel';

function EICharacteristicsPanel(): React.JSX.Element {
    const { results } = useCandidatesResultsContext();
    const { emotionalIntelligenceScore } = results;

    const characteristics = emotionalIntelligenceScore?.characteristics || [];
    return (
        <div className="grid grid-cols-2 gap-y-10 pt-10">
            {characteristics
                .sort((a, b) => {
                    return a.characteristicName.localeCompare(b.characteristicName);
                })
                .map((characteristic) => (
                    <div key={characteristic.characteristicName}>
                        <EICharacteristicPanel {...characteristic} />
                    </div>
                ))}
        </div>
    );
}

export default EICharacteristicsPanel;
